import listView from '@/data/coupon/view/list.vue'
import editorView from '@/data/coupon/view/editor.vue'

const list = {
  path: '/coupon',
  name: 'coupon-list',
  component: listView
}

const creator = {
  path: '/coupon/editor/:id(\\d+)',
  name: 'coupon-editor',
  component: editorView
}

const editor = {
  path: '/coupon/editor/:id(\\d+)',
  name: 'coupon-editor',
  component: editorView
}

export default [list, creator, editor]
